import { render } from "./Basic.vue?vue&type=template&id=3cd32284&scoped=true&ts=true"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"

import "./Basic.vue?vue&type=style&index=0&id=3cd32284&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd32284"]])

export default __exports__